export function handleTabSelection({
  nextTab,
  setActiveTab,
  setPagination,
  fetchTabData,
  shouldFetchTabData,
}) {
  setActiveTab(nextTab);
  setPagination((prev) => ({ ...prev, [nextTab]: 0 }));

  if (typeof shouldFetchTabData === "function" && shouldFetchTabData(nextTab)) {
    fetchTabData(nextTab);
  }
}

export function filterWorkOrdersByType(workOrders, workOrderType) {
  if (!Array.isArray(workOrders)) {
    return [];
  }

  if (!workOrderType || workOrderType === "All") {
    return workOrders;
  }

  const selectedType = workOrderType.trim().toLowerCase();
  return workOrders.filter((workOrder) => {
    const rowType = String(workOrder?.woType ?? workOrder?.wo_type ?? "").trim().toLowerCase();
    return rowType === selectedType;
  });
}

export function buildWorkOrderQuery({ siteId, fromDate, toDate, workOrderType }) {
  const params = new URLSearchParams();
  if (siteId !== undefined && siteId !== null && siteId !== "") {
    params.set("siteId", siteId);
  }
  if (fromDate) {
    params.set("fromDate", fromDate);
  }
  if (toDate) {
    params.set("toDate", toDate);
  }
  if (workOrderType && workOrderType !== "All") {
    params.set("type", workOrderType);
  }
  return params.toString();
}

export function isDatrplSite(selectedSite) {
  const siteName = `${selectedSite?.siteName || selectedSite?.site_name || selectedSite?.name || ""}`.toLowerCase();
  return siteName.includes("datrpl") || siteName.includes("datrpl");
}

export function isKheplSite(selectedSite) {
  const siteId = selectedSite?.id ?? selectedSite?.siteId ?? selectedSite?.site_id;
  return String(siteId) === "1";
}

export function getFuelManagementTabKey(selectedSite) {
  return isKheplSite(selectedSite) ? "fueltransaction" : "fuelpump";
}

export function shouldShowBulkActionTab(tabKey) {
  return tabKey === "fueltransaction" || tabKey === "fuelpump";
}

export function getRefreshTabsAfterDelete(sectionKey) {
  if (sectionKey === "contractor") {
    return ["contractor", "contractorwork", "contractorpayment"];
  }

  if (sectionKey === "expenses") {
    return ["expenses"];
  }

  return [sectionKey];
}

export function getDateFilterExportConfig({
  activeTab,
  contractorStartDate,
  contractorEndDate,
  contractorworkStartDate,
  contractorworkEndDate,
  contractorpaymentStartDate,
  contractorpaymentEndDate,
  selectedSite,
}) {
  const sectionMap = {
    contractor: {
      sectionKey: "contractor",
      startDate: contractorStartDate,
      endDate: contractorEndDate,
      filename: "contractors",
    },
    contractorwork: {
      sectionKey: "contractorwork",
      startDate: contractorworkStartDate,
      endDate: contractorworkEndDate,
      filename: "contractor_work",
    },
    contractorpayment: {
      sectionKey: "contractorpayment",
      startDate: contractorpaymentStartDate,
      endDate: contractorpaymentEndDate,
      filename: "contractor_payment",
    },
  };

  const config = sectionMap[activeTab];
  if (!config) {
    return null;
  }

  return {
    ...config,
    siteId: selectedSite?.id ?? null,
  };
}
